import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, XCircle } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import api from "../lib/api";

export default function PaypalReturn() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { lang } = useI18n();
  const { refresh } = useAuth();
  const [state, setState] = useState("processing"); // processing | fail
  const tries = useRef(0);

  useEffect(() => {
    const flow = params.get("flow");
    const sessionId = flow === "boost"
      ? params.get("token")
      : (params.get("subscription_id") || params.get("token"));
    if (!sessionId) { setState("fail"); return; }
    let timer;
    const confirm = async () => {
      try {
        const { data } = await api.post("/paypal/confirm", { session_id: sessionId });
        if (data.payment_status === "paid") {
          await refresh();
          window.location.replace(`/payment/success?session_id=${sessionId}`);
          return;
        }
      } catch { /* retry */ }
      tries.current += 1;
      if (tries.current >= 12) { setState("fail"); return; }
      timer = setTimeout(confirm, 2500);
    };
    confirm();
    return () => clearTimeout(timer);
  }, [params, refresh]);

  const t = {
    es: { proc: "Confirmando tu pago con PayPal…", fail: "No hemos podido confirmar el pago", back: "Volver a los planes" },
    en: { proc: "Confirming your PayPal payment…", fail: "We couldn't confirm the payment", back: "Back to plans" },
    it: { proc: "Conferma del pagamento PayPal in corso…", fail: "Non siamo riusciti a confermare il pagamento", back: "Torna ai piani" },
  }[lang] || { proc: "Confirmando tu pago con PayPal…", fail: "No hemos podido confirmar el pago", back: "Volver a los planes" };

  return (
    <div className="min-h-[70vh] grid place-items-center px-4" data-testid="paypal-return-page">
      <div className="bg-white border border-slate-200 rounded-3xl p-8 text-center max-w-sm w-full">
        {state === "processing" ? (
          <>
            <span className="h-16 w-16 mx-auto grid place-items-center rounded-2xl bg-teal-50 text-[#008080]"><Loader2 className="h-9 w-9 animate-spin" /></span>
            <p className="mt-4 font-display font-bold text-lg">{t.proc}</p>
          </>
        ) : (
          <>
            <span className="h-16 w-16 mx-auto grid place-items-center rounded-2xl bg-rose-50 text-rose-600"><XCircle className="h-9 w-9" /></span>
            <p className="mt-4 font-display font-bold text-lg">{t.fail}</p>
            <Button data-testid="paypal-return-back" onClick={() => navigate("/planes")} className="w-full mt-5 bg-[#008080] hover:bg-[#006666]">{t.back}</Button>
          </>
        )}
      </div>
    </div>
  );
}
